import { motion } from "framer-motion";
import { Move, Zap, Bike, CloudRain, Lock, Mountain } from "lucide-react";

const PROBLEMS = [
  { icon: Move, title: "Normal backpacks move around", body: "Every corner becomes a fight. Straps shift. Weight swings. The bag wins." },
  { icon: Zap, title: "Hard to access while riding", body: "Pull over for every phone, wallet or document. Time you don't have." },
  { icon: Bike, title: "Not designed for motorcycle comfort", body: "Built for offices and gyms. Not for two hours on a Road Glide." },
  { icon: CloudRain, title: "Poor weather resistance", body: "One storm and your gear is soaked. Not okay when you ride year-round." },
  { icon: Lock, title: "Not enough secure storage", body: "Passport. Cards. Cash. Devices. No place riders can actually trust." },
  { icon: Mountain, title: "Not built for real long rides", body: "Day trips? Maybe. A real adventure across states? Forget it." },
];

export const RiderProblems = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-28 md:py-36 bg-[#0A0A0C] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="section-mark" />
            <span className="overline">Why ROADRIG Exists</span>
          </div>
          <h2 className="h-section text-white text-4xl sm:text-5xl lg:text-6xl">
            Six problems. <br />
            <span className="text-white/40">No real solution.</span>
          </h2>
          <p className="mt-6 text-white/60 text-base sm:text-lg max-w-2xl">
            Every rider knows these. None of them get solved properly — until you build it yourself.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PROBLEMS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.07 }}
              className="relative p-7 bg-[#141417] border border-white/5 rounded-sm hover:border-[#F47A20]/40 transition-all group"
              data-testid={`why-item-${i}`}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 grid place-items-center bg-[#1A1A1D] border border-white/5 group-hover:border-[#F47A20]/40 rounded-sm transition-colors">
                  <p.icon size={20} className="text-[#F47A20]" strokeWidth={1.5} />
                </div>
                <span className="serial text-[10px] text-white/25">0{i + 1}</span>
              </div>
              <h3 className="h-display text-lg text-white mb-3 leading-tight">{p.title}</h3>
              <p className="text-sm text-white/55 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 p-8 md:p-10 bg-[#141417] border border-[#F47A20]/30 rounded-sm">
          <div className="serial text-[10px] text-[#F47A20] mb-3">THE ROADRIG ANSWER</div>
          <p className="h-section text-2xl sm:text-3xl text-white max-w-3xl">
            One bag. Built around all six problems. Engineered from real rider experience — not a brief from a buyer.
          </p>
        </div>
      </div>
    </section>
  );
};
